/*----------------------------------
- AGENDA PRESENTATION
----------------------------------*/

/**
 * @docs docs/features/agenda
 * @rule Presentation only. The month links, the list grouping and the place wording are the
 *       shared rules of `@uniquedomains/components/agenda` (one rule for `/agenda` and Product's
 *       `/calendar`); this file keeps the website's own country naming.
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { resolveIsoCountryName } from '@uniquedomains/core/geo';

/*----------------------------------
- PLACES
----------------------------------*/

/**
 * A country's English name, for the country facet and the `Event` JSON-LD (`addressCountry`
 * keeps the code). An event's place line prints `city, CC` (`formatEventPlace`) instead.
 */
export const formatAgendaCountry = (code: string): string => resolveIsoCountryName(code) ?? code;
